import { BlueButton } from "@react-solutions-ui/findmore-ui";
import { WhiteButton } from "@react-solutions-ui/findmore-ui";
import Dropdown from "./Dropdown";
import styles from "./MobileFilters.module.css";
import { CloseOutlined } from "@ant-design/icons";

interface MobileFiltersProps {
  onDismiss: () => void;
  onApply: () => void;
  states: string[];
  setSelectedState: (state: string) => void;
  selectedState: string;
  orderFilter: string;
  setOrderFilter: (order: string) => void;
  hasActiveFilters: boolean;
  sameFilters: boolean;
  handleClearFilters: () => void;
  lastAppliedFilters: string[];
}

export default function MobileFilters({
  onDismiss,
  onApply,
  states,
  setSelectedState,
  selectedState,
  orderFilter,
  setOrderFilter,
  hasActiveFilters,
  sameFilters,
  handleClearFilters,
  lastAppliedFilters,
}: MobileFiltersProps) {
  return (
    <div>
      <div className={styles.mobileFiltersContainer}>
        <div className={styles.mobileFiltersHeader}>
          <h3 className={styles.mobileFiltersHeaderTitle}>Filtros</h3>
          <button
            className={styles.mobileFiltersHeaderCloseButton}
            onClick={() => {
              setSelectedState(lastAppliedFilters[0]);
              setOrderFilter(lastAppliedFilters[2]);
              onDismiss();
            }}
          >
            <CloseOutlined
              style={{ fontSize: "20px", color: "rgb(19, 19, 19)" }}
            />
          </button>
        </div>
        <div className={styles.mobileFiltersContent}>
          <Dropdown
            label="Estados"
            options={states}
            selectedValue={selectedState}
            onSelect={setSelectedState}
          />
          <Dropdown
            label="Ordenar por"
            options={[
              "Nome (A-Z)",
              "Nome (Z-A)",
              "Data mais próxima",
              "Data mais distante",
            ]}
            selectedValue={orderFilter}
            onSelect={setOrderFilter}
          />
        </div>
        <div className={styles.mobileFiltersFooter}>
          <WhiteButton
            className={`${styles.mobileFiltersFooterButton} ${styles.mobileFiltersFooterButtonWhite}`}
            text="Limpar filtros"
            onClick={() => {
              handleClearFilters();
            }}
            disabled={!hasActiveFilters}
          />
          <BlueButton
            className={styles.mobileFiltersFooterButton}
            text="Aplicar"
            onClick={() => {
              onApply();
            }}
            disabled={sameFilters}
          />
        </div>
      </div>
    </div>
  );
}
